import { useDispatch } from "react-redux";
import { authActions } from "../store/auth-Slice";
import { serviceActions } from "../store/service-Slice";

const HandleResponseData = (result) => {
    let OutPutPins = [5, 6, 13, 19];
    if (result.data[0].type == "S"){
        OutPutPins = [5, 6, 13, 19, 25, 26, 27, 28];
    }

    const data = result?.data?.[0] || result;

    const {
        id,
        name,
        mac,
        key,
        ip,
        host,
        uuid,
        online,
        created,
        lastLoggedIn,
        status,
        tag,
        networkType,
        deviceDetails,
        firmware,
        type,
        numInput,
        numOutput,
        subGroup,
        deviceExtraDetails,
        latestFirmware,
        deviceName,
        monitoredBy,
        active,
        liveViewEnabled,
        scheduleOnly,
        iglooLocks, 
        integrationRelationships, 
        todaysSchedules, 
        country_code,
        site_type,
        billable, 
        ownedByGID,
        billedToGID, 
        billingFrequency,
        firstInvoiceDate,
        lastInvoiceDate
    } = data || {}

    // Passing Single Device Details to redux store to make these details availabe to other components. e.g. header
    const DeviceDetailsParsed = JSON.parse(deviceDetails);

    const dispatch = useDispatch();

    const DeviceExtraDetailsParsed = JSON.parse(deviceExtraDetails);
    dispatch(serviceActions.setDeviceDetails([DeviceDetailsParsed, id, DeviceExtraDetailsParsed]));

    const allPinsNotificationActive = DeviceDetailsParsed.allPinsNotificationActive;
    const allPinsNotificationSound = DeviceDetailsParsed.allPinsNotificationSound;
    const camectIntegrationType = DeviceDetailsParsed.camectIntegrationType;
    const singleDeviceName = DeviceDetailsParsed.name;
    const offlineNotificationActive = DeviceDetailsParsed.offlineNotificationActive;
    const offlineNotificationSound = DeviceDetailsParsed.offlineNotificationSound;
    const onlineNotificationActive = DeviceDetailsParsed.onlineNotificationActive;
    const onlineNotificationSound = DeviceDetailsParsed.onlineNotificationSound;
    const polarity = DeviceDetailsParsed.polarity;
    const polarityReason = DeviceDetailsParsed.polarityReason;
    

    const singleDeviceSettingData = 
        { 
            online, 
            numOutput, 
            numInput, 
            allPinsNotificationActive, 
            allPinsNotificationSound, 
            camectIntegrationType, 
            singleDeviceName, 
            offlineNotificationActive, 
            onlineNotificationActive, 
            offlineNotificationSound, 
            onlineNotificationSound, 
            polarity, 
            polarityReason, 
            lastLoggedIn, 
            iglooLocks, 
            monitoredBy, 
            active, 
            liveViewEnabled, 
            scheduleOnly,
            integrationRelationships, 
            todaysSchedules,
            country_code,
            site_type,
            billable, 
            ownedByGID,
            billedToGID, 
            billingFrequency,
            firstInvoiceDate,
            lastInvoiceDate
        }

    // Parsing the Pins out into OutPut Pins / Input Pins - also added the pin number as a property to the OutPut Object.
    const DeviceOutputPins = OutPutPins.map((output) => { const value = DeviceDetailsParsed[output]; return { ...value, Pin: output }; }).filter((obj) => obj !== undefined);
    let InputPins = [];

    if (numInput != 0) {
        let DeviceInputPins = [];
        if (DeviceDetailsParsed && numInput !== 0) {
            const pinMapping = numInput === 4 
                ? [21, 20, 16, 12] 
                : numInput === 8 
                    ? [21, 20, 16, 12, 4, 3, 2, 1] 
                    : [];

            DeviceInputPins = pinMapping
                .map(pin => {
                    const value = DeviceDetailsParsed[pin];
                    return value ? { ...value, Pin: pin } : null;
                })
                .filter(Boolean); 
        }




    const obj = JSON.parse(deviceExtraDetails);


        //Input Device Icons
        let InputDeviceIcons = [];

        if (numInput == 4) {
            const InputsPins = [21, 20, 16, 12];
            //Input Device Icons
            InputDeviceIcons = InputsPins?.map((input) => JSON.parse(deviceExtraDetails)[input]).filter((value) => value !== undefined);
        } else if (numInput == 8) {
            const InputsPins = [21, 20, 16, 12, 4, 3, 2, 1];
            InputDeviceIcons = InputsPins?.map((input) => JSON.parse(deviceExtraDetails)[input]).filter((value) => value !== undefined);
        }


        const arrayOfInputDeviceIcons = Object.values(InputDeviceIcons);
        const arrayOfInputDeviceIconsValues = arrayOfInputDeviceIcons.map(obj => obj.icon);
        const arrayOfInputManagerOnlyValues = arrayOfInputDeviceIcons.map(obj => obj.accessLevel);
        const arrayOfInputReadOnlyValues = arrayOfInputDeviceIcons.map(obj => obj.readOnly);


        // debugger;
        InputPins = DeviceInputPins?.map((item, index) => {
            let icon = arrayOfInputDeviceIconsValues[index] || 'default.svg';
            let accessLevel = arrayOfInputManagerOnlyValues[index] || null;
            let readOnly = arrayOfInputReadOnlyValues[index] || null;

            let DeviceUUID = uuid;
            let DeviceType = type;
        
            if (typeof icon === 'string' && icon.includes('.png')) {
                icon = icon.slice(0, -4); // remove .png safely
            }
        
            return { ...item, icon, accessLevel, readOnly, DeviceUUID, DeviceType };
        });
        

    }
    const OutputDeviceIcons = OutPutPins?.map((output) => JSON.parse(deviceExtraDetails)[output]).filter((value) => value !== undefined);
    const relationshipMap = Object.fromEntries(
        integrationRelationships.map(r => [Number(r.pin), r.missed_polls])
    );

    const missedPollsObj = OutPutPins.map(pin => ({
        pin,
        missed_polls: relationshipMap[pin] ?? 0
    }));
    const arrayOfOutputDeviceIcons = Object.values(OutputDeviceIcons);
    const arrayOfOutputDeviceIconsValues = arrayOfOutputDeviceIcons.map(obj => obj.icon);
    const arrayOfOutputManagerOnlyValues = arrayOfOutputDeviceIcons.map(obj => obj.accessLevel);
    const arrayOfOutputReadOnlyValues = arrayOfOutputDeviceIcons.map(obj => obj.readOnly);

    const OutputPins = DeviceOutputPins?.map((item, index) => {
        let icon = arrayOfOutputDeviceIconsValues[index];
        let accessLevel = arrayOfOutputManagerOnlyValues[index];
        let readOnly = arrayOfOutputReadOnlyValues[index];
        let missedPolls = missedPollsObj[index].missed_polls
        let DeviceUUID = uuid;
        let DeviceType = type;
  
        
        if (typeof icon === 'string' && icon.includes('.png')) {
            icon = icon.slice(0, -4);
        }
        return { ...item, icon, accessLevel, readOnly, DeviceUUID, DeviceType, missedPolls };
    });

    const ResponseData = [
        { OutputPins, InputPins, singleDeviceSettingData },
        { id, name, mac, key, ip, host, uuid, online, created, lastLoggedIn, status, tag, networkType, firmware, type, subGroup, numInput, numOutput, latestFirmware, camectIntegrationType, deviceName, monitoredBy, active, liveViewEnabled, scheduleOnly, country_code, site_type, billable, ownedByGID,
            billedToGID, 
            billingFrequency,
            firstInvoiceDate, 
            lastInvoiceDate  }
    ]
    return ResponseData;
}

export default HandleResponseData;